var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"genres"},_vm._l((_vm.genres),function(genre,key){return _c('div',{key:key,staticClass:"genre"},[_vm._v(_vm._s(genre))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }